<template>
<div>
  <div class="title">
    <h2 class="section-title"> Contact</h2>
  </div>
  <div class="container">
    <div class="row contact-form">
      <div class="col-lg-9 contact-panel">
        <div class="mb-3">
          <h5>Mă puteți contacta direct prin formularul următor.</h5>
        </div>
        <form id="contact-form" method="post" action="" role="form" @submit.prevent="checkForm">
        <div class="messages"></div>
        <div class="controls">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="form_name">Nume <span class="text-danger">*</span></label>
                <input id="form_name"  v-model="contactForm.firstName" type="text" name="name" class="form-control" placeholder="Nume">
                <div class="help-block with-errors text-danger"></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="form_lastname">Prenume <span class="text-danger">*</span></label>
                <input id="form_lastname" v-model="contactForm.lastName" type="text" name="surname" class="form-control" placeholder="Prenume">
                <div class="help-block with-errors"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="form_email">E-mail <span class="text-danger">*</span></label>
                <input id="form_email" v-model="contactForm.email" type="text" name="email" class="form-control" placeholder="E-mail">
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="form_phone">Telefon <span class="text-danger">*</span></label>
                <input id="form_phone" v-model="contactForm.phone" type="tel" name="phone" class="form-control" placeholder="Telefon">
                <div class="help-block with-errors"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="form-group"><label for="subject">Subiect <span class="text-danger">*</span></label>
                <input type="text" v-model="contactForm.subject" class="form-control" placeholder="Subiect">
                <div class="help-block with-errors"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="form_message">Mesaj <span class="text-danger">*</span></label>
                <textarea 
                  id="form_message" 
                  rows="8" 
                  v-model="contactForm.message" 
                  name="message" 
                  class="form-control" 
                  placeholder="Mesaj">
                </textarea>
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-md-12">
              <p><span class="text-danger">*</span> câmp obligatoriu</p>
            </div>
            <div class="col-md-12 col-lg-12" v-if="errors.length > 0">
              <div class="alert alert-danger" role="alert">
                <p>Exist urmatoarele erori:</p>
                <p v-for="(error, index) in errors" v-bind:key="index">
                  {{error}}
                </p>
              </div>
            </div>
            <div class="col-md-12 col-lg-12" v-if="isSuccessMessage">
              <div class="alert alert-success alert-dismissible fade show" role="alert">
                <span>Mesajul a fost trimis cu succes. Va multumim!</span>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <vue-recaptcha
                ref="recaptcha"
                @verify="onCaptchaVerified"
                @expired="onCaptchaExpired"
                sitekey="6LdTfRkcAAAAAC7onOjPPPUs_nb3rf0ctCLjybpP">
              </vue-recaptcha>
            </div>
            <div class="col-md-12 buttons-container">
              <button @click.prevent="reset()" class="btn btn-outline-danger btn-cancel pull-right">
                <i class="fa fa-close"></i> Anuleaza
              </button>
              <button type="submit" class="btn btn-outline-dark btn-send pull-right mr-2" >
                <i class="fa fa-send"></i> Trimite
              </button>
            </div>
          </div>
        </div>
        </form>
      </div>
    </div>
  </div>
  
</div>
</template>
<script>
import { ADDRESS, SITE_KEY } from '../constants';
import VueRecaptcha from 'vue-recaptcha';
export default {
  name: 'Contact',
  components: { VueRecaptcha },
  data() {
    return {
      siteKey: SITE_KEY,
      isOverlay: false,
      contactForm: {
        firstName: '',
        lastName: '',
        email: '', 
        phone: '',
        subject: '',
        message: '',
      },

      fieldsName: {
        firstName: 'Prenumele',
        lastName: 'Numele',
        email: 'Adresa de e-mail', 
        phone: 'Telefonul',
        subject: 'Subiectul',
        message: 'Mesajul',
      },
      errors:[],
      isTouched: false,
      address: ADDRESS,
      regMail: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      regPhone: /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
      isRecaptchaChecked: false,
      isSuccessMessage: false
    }
  },
  methods: {
    checkForm() {
      this.errors = [];
      this.isTouched = true;
      for (const key in this.contactForm) {
        if (Object.hasOwnProperty.call(this.contactForm, key)) {
          if(!this.contactForm[key]) {
            this.errors.push(`${this.fieldsName[key]} este obligatoriu.`);
          }
          if(this.contactForm[key] && key === 'email') {
            if(!this.regMail.test(this.contactForm.email)) {
              this.errors.push('Adresa de email nu are formatul corect.');
            }
          }
          if(this.contactForm[key] && key === 'phone') {
            if(!this.regPhone.test(this.contactForm.phone)) {
              this.errors.push('Numarul de telefon nu are formatul corect.');
            }
          }
        }
      }

      if (!this.isRecaptchaChecked) {
        this.errors.push('Este necesara validatarea ca nu sunteti un robot.');
      }
      
      if (this.errors.length === 0 && this.isRecaptchaChecked) {
        this.sendEmail();
        this.onCaptchaExpired();
      }
    },
    sendEmail () {
      fetch("https://email.avocatnegrumarian.com/email", {
        method: "POST",
        body: JSON.stringify({ contactForm: this.contactForm }),
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      })
      .then(() => { 
        this.isSuccessMessage = true;
        this.reset();
        this.closeSuccessMessage();
      })
      .catch((error => console.log(error)
      ))
    },
    reset() {
      for (const formProp in this.contactForm) {
        if (Object.hasOwnProperty.call(this.contactForm, formProp)) {
          this.contactForm[formProp] = '';
        }
      }
      this.errors = [];
      this.onCaptchaExpired();
    },
    onCaptchaVerified () {
      this.isRecaptchaChecked = true;
    },
    onCaptchaExpired () {
      this.isRecaptchaChecked = false;
      this.$refs.recaptcha.reset();
    },
    closeSuccessMessage() {
      setTimeout(() => {
        this.isSuccessMessage = false;
      }, 10000);
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../scss/_variables.scss";
.contact-form {
  justify-content: center;
  img {
    margin-bottom: 30px;
  }
}

.title {
  text-align: center;
  padding: 0 15px;
  margin-bottom: 10px;
  p {
    font-size: 18px;
  }
}

@media only screen and (max-width: 767px) {
  .buttons-container {
    margin-top: 30px;
  }
}
</style>
